export default __webpack_public_path__ + "static/media/info-circle.111fc505.svg";